
import gql from 'graphql-tag';

export const getCatalogueCategories = gql`

query getCatalogueCategories {
  catalogue_categories(where: {status: {_eq: "ACTIVE"}}){
    id
    name
  }
}

`;


export const getPermissions = gql`

query getPermissions {
  permissions{
    id
    role
    dashboard_permissions
  }
}

`;




export const addSubPlans = gql`

mutation addSubPlans($subPlans: subscription_plans_insert_input!) {
  insert_subscription_plans_one(object: $subPlans) {
    id
  }
}

`;

export const addSubPlansCatalogs = gql`

mutation addSubPlansCatalogs($catagoriesData: subscription_plans_catalogues_categories_insert_input!) {
  insert_subscription_plans_catalogues_categories_one(object: $catagoriesData) {
    id
  }
}

`;


export const getSubPlan = gql`
subscription getSubPlan{
    subscription_plans{
    id
    updated_at
    name
    coming_soon
    display_price
    yearly_price
    monthy_price
    tenure_in_days
    tenure_type
    stripe_product_id
    stripe_price_id
    terms_and_conditions
    type
    plan_type
    description
    benefits
    plan_status
    
  }
}
`;


export const updatePlanStatus = gql`

mutation updatePlanStatus($id: uuid!, $updateObj: subscription_plans_set_input!) {
  update_subscription_plans_by_pk(pk_columns: {id: $id},_set: $updateObj) {
    id
   
  }
}
`;

export const getSubPlanViewById = gql`
query getSubPlanViewById($id: uuid!){
    subscription_plans_by_pk(id:$id){
    id
    updated_at
    name
    coming_soon
    display_price
    monthy_price
    yearly_price
    tenure_in_days
    tenure_type
    terms_and_conditions
    stripe_product_id
    stripe_price_id
    type
    plan_type
    description
    benefits
    permissions
    subscription_plans_catalogues_categories{
      count
      catalogue_category{
        name
      }
    }


  }
}
`;




export const getSubPlanCatCount = gql`
query getSubPlanCatCount($id: uuid!){
  subscription_plans_catalogues_categories(where:{subsciption_plan_id:{_eq:$id}}){
    id
    catalogue_category_id
    count


  }
}
`;

// Update subscription plan mutation
export const updateSubscriptionPlan = gql`
  mutation UpdateSubscriptionPlan($id: uuid!, $planData: subscription_plans_set_input!) {
    update_subscription_plans_by_pk(pk_columns: {id: $id}, _set: $planData) {
      id
      name
      type
      plan_type
      terms_and_conditions
      yearly_price
      monthy_price
      permissions
      benefits
    }
  }
`;

// Update subscription plan catalog mutation
export const updateSubscriptionPlanCatalog = gql`
  mutation UpdateSubscriptionPlanCatalog($id: uuid!, $catalogData: subscription_plans_catalogues_categories_set_input!) {
    update_subscription_plans_catalogues_categories_by_pk(pk_columns: {id: $id}, _set: $catalogData) {
      id
      count
      catalogue_category_id
      subsciption_plan_id
    }
  }
`;